import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

const card = { background: 'var(--field)', border: '1px solid var(--rule-strong)', borderRadius: 14, padding: '14px 16px', marginBottom: 10 };

export default function LegacyKpi() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [month, setMonth] = useState((new Date().getMonth() + 1).toString());

  useEffect(() => {
    setLoading(true);
    api.getKpi({ year, month }).then(setRecords).catch(() => setRecords([])).finally(() => setLoading(false));
  }, [year, month]);

  return (
    <div style={{ maxWidth: 560, margin: '0 auto', padding: 'var(--s6) var(--s4) 120px' }}>
      <div style={{ marginBottom: 20 }}>
        <div style={{ display: 'inline-block', padding: '4px 12px', background: 'var(--loss-bg)', border: '1px solid #6B3A36', borderRadius: 8, fontSize: 'var(--t-note)', color: 'var(--loss)', marginBottom: 8 }}>旧システムデータ（閲覧のみ）</div>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: 'var(--ink)' }}>旧KPI履歴</h1>
      </div>

      {/* フィルタ */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
        <select value={year} onChange={e => setYear(e.target.value)} style={{ padding: '8px 12px', background: 'var(--paper-sunk)', border: '1px solid var(--rule-strong)', borderRadius: 8, color: 'var(--ink)', fontSize: 'var(--t-note)' }}>
          {['2024','2025','2026'].map(y => <option key={y} value={y}>{y}年</option>)}
        </select>
        <select value={month} onChange={e => setMonth(e.target.value)} style={{ padding: '8px 12px', background: 'var(--paper-sunk)', border: '1px solid var(--rule-strong)', borderRadius: 8, color: 'var(--ink)', fontSize: 'var(--t-note)' }}>
          {Array.from({length:12},(_,i)=>i+1).map(m => <option key={m} value={m}>{m}月</option>)}
        </select>
      </div>

      {loading ? (
        <div style={{ color: 'var(--ink-mute)', textAlign: 'center', padding: 40 }}>読み込み中...</div>
      ) : records.length === 0 ? (
        <div style={{ color: 'var(--ink-mute)', textAlign: 'center', padding: 40 }}>データなし</div>
      ) : records.map(r => (
        <div key={r.id} style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 'var(--t-note)', fontWeight: 700, color: 'var(--ink)' }}>{r.record_date}</span>
            {r.user_name && <span style={{ fontSize: 'var(--t-note)', color: 'var(--ink-mute)' }}>{r.user_name}</span>}
          </div>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {[
              ['キャッチ', r.catch_count, 'var(--mark)'],
              ['トーク',   r.talk_count,  'var(--mark)'],
              ['着座',     r.seat_count,  'var(--mark)'],
              ['つばさ',   r.tsubasa_count, 'var(--hold)'],
              ['Looop',    r.looop_count,  'var(--gain)'],
            ].map(([lbl, val, col]) => (
              <div key={lbl} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 'var(--t-note)', color: 'var(--ink-mute)' }}>{lbl}</div>
                <div style={{ fontSize: 16, fontWeight: 800, color: col }}>{val || 0}</div>
              </div>
            ))}
          </div>
          {r.notes && <div style={{ marginTop: 8, fontSize: 'var(--t-note)', color: 'var(--ink-mute)', borderTop: '1px solid var(--rule-strong)', paddingTop: 8 }}>{r.notes}</div>}
        </div>
      ))}
    </div>
  );
}
